import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import api from "./apiClient";

import cookiesModifier from "../utils/cookies";

import { HMIApproveApplication, ISubmittedImmigrationApplicationsForConsultant } from "../types/immigration_application.mix";

export const useGetSubmittedImmigrationApplications = (applicantId: number) => {
    const queryFn = async (): Promise<ISubmittedImmigrationApplicationsForConsultant[]> => {
        const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const res = await api.get(`/ia-trackings/submitted-applications-for-consultant/${applicantId}`);
        return res.data;
    };

    return useQuery({
        queryKey: ['submitted-immigration-applications', applicantId],
        queryFn,
        retry: 0,
        refetchOnWindowFocus: false,
    });
};

export const useApproveOrResetApplication = () => {
    const queryClient = useQueryClient();

    const mutationFn = async (data: HMIApproveApplication): Promise<void> => {
        const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const res = await api.patch(`/ia-trackings/approve-or-reset-application/${data.applicantId}/${data.iaTrackingId}`);
        return res.data;
    };

    return useMutation({
        mutationFn,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['submitted-immigration-applications'] });
        },
    });
};
